/**
 * @returns returns if the current stand has the location picker active
 */
export const getIsLocationPickerActive = (state) => {
  return state.VNLocationPicker.get('isLocationPickerActive')
}
